import CreateLevaFromJson from './CreateLevaFromJson.jsx';
import { Leva,useCreateStore } from 'leva';
import Header from './Header.jsx';

const verbose = false;

function UiPanel({iframeRef}) {
    const config = window.AppConfig;
    const store = useCreateStore();  
    const myTheme = config.theme
    verbose && console.log("THEME",myTheme )
    
    return ( 
        <div className="UI-main UI-scrollbar" > 
        <Header componentType={config.headerType} />
        <Leva
            store = {store}
            theme={myTheme} 
            oneLineLabels = {config.leva.oneLineLabels} 
            drag = {config.leva.drag}
            titleBar = {config.leva.titleBar}
            fill = {config.leva.fill}
            flat = {config.leva.flat}
            hideTitleBar = {config.leva.hideTitleBar} 
            hideCopyButton = {config.leva.hideCopyButton}
        ></Leva>
        <CreateLevaFromJson iframeRef={iframeRef} store = {store}/>
    </div> 
    );
}

export default UiPanel;